export default {
  ADD:                 'add',
  HIDDEN:              'hidden',
  PUBLISH:             'publish',
  PUBLISH_NOW:         'publishNow',
  SCHEDULE:            'schedule',
  SCHEDULE_EXPIRATION: 'scheduleExpiration',
};
